import React from 'react';

const Gungaa = () => {
    return (
        <h1>Гунгаачойлин дацан</h1>
    )
}
export default Gungaa;